import React, { useState, useEffect } from 'react';
import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Select,
  useColorModeValue,
} from '@chakra-ui/react';
import { getData } from '../../../utils/httpClient';

const ClientInfo = ({ clientData }) => {
  const [isEditing] = useState(false);
  const [formData, setFormData] = useState(clientData);
  const [clientTypes, setClientTypes] = useState([]);

  const inputColor = useColorModeValue('gray.500', 'gray.400');
  const inputColorEditing = useColorModeValue('black', 'white');

  const getClientTypes = async () => {
    try {
      const data = await getData('/customers/types');
      setClientTypes(data.payload.types);
    } catch (error) {
      console.error('Error fetching client types:', error);
    }
  };

  useEffect(() => {
    getClientTypes();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    // Handle customer type differently to set nested object value
    if (name === 'customerType') {
      setFormData((prevData) => ({
        ...prevData,
        customerType: { ...prevData.customerType, type: value },
      }));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  return (
    <Box mt="4">
      <Flex wrap="wrap" gap={4}>
        {[
          { label: 'Nombre', value: formData.name, name: 'name' },
          { label: 'Documento', value: formData.document, name: 'document' },
          { label: 'Teléfono', value: formData.phone, name: 'phone' },
          { label: 'Email', value: formData.email, name: 'email' },
          { label: 'Dirección', value: formData.address, name: 'address' },
          {
            label: 'País',
            value: formData.locality?.department?.country?.name || 'No disponible',
            name: 'country',
            isReadOnly: true,
          },
          {
            label: 'Departamento',
            value: formData.locality?.department?.name || 'No disponible',
            name: 'department',
            isReadOnly: true,
          },
          {
            label: 'Localidad',
            value: formData.locality?.name || 'No disponible',
            name: 'locality',
            isReadOnly: true,
          },
          {
            label: 'Tipo de Cliente',
            value: formData.customerType?.type || '',
            name: 'customerType',
            isSelect: true,
          },
        ].map((field, index) => (
          <FormControl
            key={index}
            mb="2"
            width={{ base: '100%', md: 'calc(50% - 16px)' }}
          >
            <FormLabel fontWeight="bold">{field.label}</FormLabel>
            {field.isSelect ? (
              <Select
                name={field.name}
                value={field.value}
                onChange={handleChange}
                isDisabled={!isEditing}
              >
                {clientTypes.map((type) => (
                  <option key={type.id} value={type.type}>
                    {type.type}
                  </option>
                ))}
              </Select>
            ) : (
              <Input
                value={field.value || ''}
                isReadOnly={field.isReadOnly || !isEditing}
                name={field.name}
                onChange={handleChange}
                color={field.isReadOnly || !isEditing ? inputColor : inputColorEditing}
              />
            )}
          </FormControl>
        ))}

        {/* Read-only fields for creation and update dates */}
        {[
          {
            label: 'Fecha de Creación',
            value: new Date(formData.createdAt).toLocaleDateString(),
          },
          {
            label: 'Última Actualización',
            value: new Date(formData.updatedAt).toLocaleDateString(),
          },
        ].map((field, index) => (
          <FormControl
            key={index}
            mb="2"
            width={{ base: '100%', md: 'calc(50% - 16px)' }}
          >
            <FormLabel fontWeight="bold">{field.label}</FormLabel>
            <Input
              value={field.value}
              isReadOnly
              color={!isEditing ? inputColor : inputColorEditing}
            />
          </FormControl>
        ))}
      </Flex>
    </Box>
  );
};

export default ClientInfo;